import axios from "axios";
import { url } from "../../../../../../App";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import styles from "./PartlyDisbursedStatus.module.css";
import { TextField } from "@mui/material";
import { fixDateHandler } from "../../../../../Loan/ViewLoanDetails/ViewLoanDetails";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";

const getTrancheDetails = async (loanId) => {
  try {
    const { data } = await axios.get(url + `/loan/tranchedetails/${loanId}`);
    return data;
  } catch (err) {
    throw new Error(err.response.data?.message);
  }
};

const PartlyDisbursedStatus = ({ loanId, setUtr }) => {
  const { data: trancheDetails, error } = useQuery({
    queryKey: ["trancheDetails"],
    gcTime: 1,
    queryFn: () => getTrancheDetails(loanId),
  });

  if (error) {
    return toast.error(error);
  }
  return (
    <>
      <div className={styles.textArea}>
        <label htmlFor="">UTR</label>
        <TextField
          size="small"
          onChange={(e) => setUtr(e.target.value)}
          variant="outlined"
          type="text"
          style={{ width: "30vw" }}
          name="ref-number"
          id="ref-number"
        />
      </div>
      <section className={styles.tancheTable}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Tranche Release Date</th>
              <th>Principal Amount</th>
              <th>Disbursed Amount</th>
              <th>UTR</th>
              <th>Disbursed</th>
            </tr>
          </thead>
          <tbody>
            {trancheDetails?.map((detail) => {
              return (
                <tr>
                  <td>{fixDateHandler(detail?.trancheReleaseDate)}</td>
                  <td>{detail.tranchePrinAmount}</td>
                  <td>{detail.trancheAmount}</td>
                  <td>{detail.trancheUtr}</td>
                  <td>
                    {detail.isDisbursed ? (
                      <FaCheck color="green" />
                    ) : (
                      <ImCross />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    </>
  );
};

export default PartlyDisbursedStatus;
